import React, { useEffect } from 'react';
import { Modal, Form, Switch, InputNumber, Checkbox } from 'antd';
import { useTheme } from '@/components/common/ThemeProvider';

interface PasswordConfigProps {
    open: boolean;
    onCancel: () => void;
    onSave: (config: PasswordConfig) => void;
    initialConfig: PasswordConfig;
}

export interface PasswordConfig {
    initialPassword: boolean;
    minimumLength: number;
    requireUppercase: boolean;
    requireLowercase: boolean;
    requireNumbers: boolean;
    requireSpecialChars: boolean;
}

export const PasswordConfigDialog: React.FC<PasswordConfigProps> = ({
                                                                        open,
                                                                        onCancel,
                                                                        onSave,
                                                                        initialConfig,
                                                                    }) => {
    const [form] = Form.useForm();
    const { dark } = useTheme();

    useEffect(() => {
        if (open) {
            form.setFieldsValue(initialConfig);
        }
    }, [open, initialConfig, form]);

    const handleSubmit = () => {
        form.validateFields().then(values => {
            onSave(values);
        });
    };

    return (
        <Modal
            title="Password Configuration"
            open={open}
            onCancel={onCancel}
            onOk={handleSubmit}
            className={dark ? 'dark' : ''}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={initialConfig}
            >
                <Form.Item
                    name="initialPassword"
                    label="Password Setting Mode"
                    valuePropName="checked"
                >
                    <Switch
                        checkedChildren="Admin sets password"
                        unCheckedChildren="System generates password"
                    />
                </Form.Item>

                <Form.Item
                    name="minimumLength"
                    label="Minimum Password Length"
                    rules={[{ required: true }]}
                >
                    <InputNumber min={6} max={32} />
                </Form.Item>

                <Form.Item
                    name="requireUppercase"
                    valuePropName="checked"
                >
                    <Checkbox>Require Uppercase Letters</Checkbox>
                </Form.Item>

                <Form.Item
                    name="requireLowercase"
                    valuePropName="checked"
                >
                    <Checkbox>Require Lowercase Letters</Checkbox>
                </Form.Item>

                <Form.Item
                    name="requireNumbers"
                    valuePropName="checked"
                >
                    <Checkbox>Require Numbers</Checkbox>
                </Form.Item>

                <Form.Item
                    name="requireSpecialChars"
                    valuePropName="checked"
                >
                    <Checkbox>Require Special Characters</Checkbox>
                </Form.Item>
            </Form>
        </Modal>
    );
};
